import React from 'react';

import { Box } from '@rover/kibble/core';
import LoadingShimmer from '@rover/kibble/patterns/LoadingShimmer';

const WhatToExpectFormShimmer = (): JSX.Element => (
  <Box data-testid="what-to-expect-form-shimmer">
    <Box mb="6x">
      <LoadingShimmer width={120} height={16} mb="1x" mx="0x" />
      <LoadingShimmer width="100%" height={14} mb="2x" mx="0x" />
      <LoadingShimmer width="100%" height={130} mx="0x" />
    </Box>

    <Box mb="6x">
      <LoadingShimmer width={180} height={16} mb="1x" mx="0x" />
      <LoadingShimmer width="100%" height={14} mb="2x" mx="0x" />
      <LoadingShimmer width="100%" height={130} mx="0x" />
    </Box>
  </Box>
);

export default WhatToExpectFormShimmer;
